import { apiList } from "../api/apiList";
import axiosInstance from "../api/axiosInstance";
import axiosInstance2 from "../api/axiosInstance2";

const reportService = {
  getDifferentOddVouchers: () => axiosInstance.get(apiList.differentOddVouchersApi),
  rejectVoucher: (payload) => axiosInstance.post(apiList.rejectVoucherApi,payload),

  reportByEvent : (date) => axiosInstance2.get(`${apiList.eventReportApi}/${date}`),
  purchaseVoucher : (payload) => axiosInstance2.post(apiList.purchaseVoucherApi,payload),

  reportByPurchased : (date) => axiosInstance2.get(`${apiList.purchasedReportApi}/${date}`),
  updatePurchasedVoucher :(payload) => axiosInstance2.put(`${apiList.purchasedReportApi}`,payload),
  deletePurchasedVoucher:(id) => axiosInstance2.delete(`${apiList.purchasedReportApi}/${id}`),

  reportByMixTotal : (date) => axiosInstance2.get(`${apiList.mixReportApi}/total/${date}`),
  reportByMixDetails : (payload) => axiosInstance2.post(`${apiList.mixReportApi}/details`,payload),
  reportByMixDetailsVoucer : (id) => axiosInstance2.get(`${apiList.mixReportApi}/details/voucher-info/${id}`),

  reportByVoucher : (voucher) => axiosInstance2.get(`${apiList.reportByVoucherApi}/${voucher}`),
  getUserTransaction : (payload) => axiosInstance2.post(apiList.transactionApi,payload),

  getGamblingLimit : () => axiosInstance2.get(apiList.gamblingLimitApi),
  updateGamblingLimit : (payload) => axiosInstance2.put(apiList.gamblingLimitApi,payload),

  winloseReport : (payload) => axiosInstance2.post(apiList.winLoseReportApi,payload),
  winloseReportDetails : (payload) => axiosInstance2.post(apiList.winLoseReportDetailsApi,payload),
  winloseReportVoucher : (payload) => axiosInstance2.post(apiList.winLoseReportVoucherApi,payload),

  dashboardBetting : (payload) => axiosInstance2.post(apiList.getDashboardBettingApi,payload),
  dashboardUser : (payload) => axiosInstance2.post(apiList.getDashboardUserApi,payload),

  getminmax2 : () => axiosInstance2.get(apiList.getmixmax2Api),
  updateminmax2 : (payload) => axiosInstance2.put(apiList.updateminmaxApi, payload)
}

export default reportService;
